import { Component, Inject, forwardRef } from '@angular/core';
import { SetupWarningPopup } from './setup-warning-popup.component';
import { NewPlanForm } from 'sharedFeatures/newplan-win';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'setup-warning-popup-body',
    templateUrl: './setup-warning-popup-body.component.html',
    styleUrls: ['./setup-warning-popup-body.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, TranslateModule]
})
export class SetupWarningPopupBody {

    private parent: SetupWarningPopup;

    dontQuitText = $localize`DONOT_QUIT`;
    quitText = $localize`QUIT`;

    constructor(
        @Inject(forwardRef(() => SetupWarningPopup)) parent: SetupWarningPopup
    ) {

        this.parent = parent;

    }


    handleQuit() {

        this.parent.close();
        (<NewPlanForm>this.parent.getOwner()).onClose();        


    }

    handleDontQuit() {

        this.parent.close();

    }


}